import { render, staticRenderFns } from "./GSGNFTContent.vue?vue&type=template&id=38182318&scoped=true"
import script from "./GSGNFTContent.vue?vue&type=script&lang=js"
export * from "./GSGNFTContent.vue?vue&type=script&lang=js"
import style0 from "./GSGNFTContent.vue?vue&type=style&index=0&id=38182318&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38182318",
  null
  
)

export default component.exports